module.exports = __webpack_public_path__ + "img/bg-blue-black.10fc10e8.png";